/* Info-„i“ (snippets/gp-info.liquid): Antippen öffnet/schließt (Touch), Esc und Klick außerhalb schließen.
   Lage: über dem „i“, bei Platzmangel darunter, seitlich im Sichtbereich gehalten; folgt beim Scrollen. */
(function () {
  'use strict';
  var uid = 0, M = 12;
  function place(info) {
    var tip = info.querySelector('.gp-info__tip'), btnEl = info.querySelector('.gp-info__btn');
    if (!tip || !btnEl) return;
    var b = btnEl.getBoundingClientRect(), vw = document.documentElement.clientWidth;
    var w = tip.offsetWidth, h = tip.offsetHeight;
    var left = Math.min(Math.max(b.left + b.width / 2 - w / 2, M), vw - M - w);
    var below = b.top - h - 8 < M;
    info.classList.toggle('gp-info--below', below);
    var top = below ? b.bottom + 8 : b.top - h - 8;
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    // In Containern mit transform (z. B. Warenkorb-Drawer) bezieht sich fixed auf den Container – nachmessen, ausgleichen
    var r = tip.getBoundingClientRect(), dx = left - r.left, dy = top - r.top;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
      tip.style.left = Math.round(left + dx) + 'px';
      tip.style.top = Math.round(top + dy) + 'px';
    }
  }
  function active() { return document.querySelectorAll('[data-gp-info].is-open, [data-gp-info]:hover, [data-gp-info]:focus-within'); }
  function init(info) {
    if (info.hasAttribute('data-gp-info-init')) return;
    info.setAttribute('data-gp-info-init', '');
    var btn = info.querySelector('.gp-info__btn'), tip = info.querySelector('.gp-info__tip');
    if (!btn || !tip) return;
    tip.id = tip.id || ('gp-info-tip-' + (++uid));
    btn.setAttribute('aria-describedby', tip.id);
    info.addEventListener('mouseenter', function () { place(info); });
    btn.addEventListener('focus', function () { place(info); });
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var open = !info.classList.contains('is-open');
      closeAll(info);
      info.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) place(info);
    });
  }
  function closeAll(except) {
    document.querySelectorAll('[data-gp-info].is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      var b = el.querySelector('.gp-info__btn'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function boot() { document.querySelectorAll('[data-gp-info]:not([data-gp-info-init])').forEach(init); }
  var raf = 0;
  function follow() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; active().forEach(place); }); }
  window.addEventListener('scroll', follow, { passive: true, capture: true });
  window.addEventListener('resize', follow, { passive: true });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-gp-info]')) closeAll(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var el = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-gp-info]');
    closeAll();
    if (el) document.activeElement.blur();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  new MutationObserver(function (muts) { for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { boot(); return; } } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
